var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EBEFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6720_59861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 28,
    height: 28,
    fill: "#547AFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6720_59861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2822 21.4548C31.663 21.4322 34.4778 24.1866 34.5079 27.5598C34.5381 31.0084 31.7535 33.8308 28.32 33.8459C24.9468 33.861 22.1471 31.0839 22.132 27.7032C22.1093 24.2545 24.8411 21.4775 28.2822 21.4473V21.4548Z",
    fill: "#547AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0637 20.5037C18.1545 20.4131 16.3132 20.1339 14.6002 19.2661C14.1323 19.0246 13.6796 18.7077 13.3098 18.3304C12.6231 17.6361 12.6608 16.9569 13.3475 16.2551C13.9814 15.5986 14.7813 15.2062 15.6265 14.9345C18.7809 13.9158 21.9201 13.9309 25.0141 15.1534C25.6027 15.3873 26.1687 15.7571 26.6517 16.1646C27.4893 16.8739 27.4742 17.6965 26.6743 18.4511C25.7461 19.334 24.5764 19.7717 23.3539 20.0207C22.2673 20.2471 21.158 20.3377 20.0562 20.4961L20.0637 20.5037Z",
    fill: "#547AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8313 22.4042C21.4465 23.0833 21.0993 23.7248 20.7296 24.3511C20.6767 24.4341 20.5484 24.5247 20.4503 24.5322C18.3977 24.5775 16.4055 24.3134 14.5491 23.3701C14.202 23.189 13.87 22.9701 13.5681 22.7211C12.8663 22.1249 12.7229 21.6571 12.8663 20.6836C15.6509 22.3362 18.6845 22.6456 21.8238 22.4117L21.8313 22.4042Z",
    fill: "#547AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7258 32.721C21.2051 32.7512 20.7222 32.804 20.2316 32.804C18.4432 32.804 16.6849 32.5852 15.0322 31.8607C14.6096 31.6721 14.2097 31.4306 13.8173 31.1816C13.0249 30.6609 12.6551 29.9364 12.8513 28.978C13.4249 29.2497 13.9908 29.5591 14.587 29.793C16.3981 30.5024 18.2847 30.7741 20.2166 30.7288C20.5259 30.7288 20.6769 30.8118 20.8203 31.1061C21.0768 31.6494 21.3938 32.155 21.7183 32.7285L21.7258 32.721Z",
    fill: "#547AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8684 24.7976C15.0945 26.1559 17.532 26.5785 20.0751 26.6087V28.6764C18.9583 28.6764 17.864 28.5632 16.7774 28.2991C15.7133 28.05 14.7021 27.6803 13.8041 27.0388C13.0344 26.4955 12.6571 25.7862 12.8684 24.79V24.7976Z",
    fill: "#547AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificPayment);
export default __webpack_public_path__ + "static/media/notific_payment.820de4a46dd1131738ff6454c3c5276b.svg";
export { ForwardRef as ReactComponent };